import React, { Component } from 'react';
import Carousel, { consts } from 'react-elastic-carousel';

import CardSlider from '../../components/blog-cards/CardSlider';
import arrow from '../../assets/images/icons/arrow-left.svg';
import AutismArticlesCard from './AutismArticlesCard';
import i18next from 'i18next';

const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 400, itemsToShow: 1 },
    { width: 500, itemsToShow: 2 },
    { width: 770, itemsToShow: 3 },
    { width: 1100, itemsToShow: 4 },
    { width: 1500, itemsToShow: 5 },
    { width: 1786, itemsToShow: 6 },
];
export default class AutismArticlesCards extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    myArrow({ type, onClick, isEdge }) {
        const pointer =
            type === consts.PREV ? (
                <img
                    src={arrow}
                    alt=''
                    style={{ transform: 'rotate(180deg)' }}
                />
            ) : (
                <img src={arrow} alt='' />
            );
        return (
            <button onClick={onClick} disabled={isEdge} className='sliderBtn'>
                {pointer}
            </button>
        );
    }

    render() {
        let cards = this.props.articles.map((article) => (
            <AutismArticlesCard
                image={article.image}
                title={article.title}
                en_title={article.en_title}
                file={article.file}
                article={article.article}
            />
        ));
        return (
            <div
                className={`autism-articles-wrapper ${
                    i18next.language === 'en'
                        ? 'en-autism-articles-wrapper'
                        : ''
                }`}
            >
                <Carousel
                    breakPoints={breakPoints}
                    pagination={false}
                    isRTL={true}
                    itemPadding={[40, 15, 40, 15]}
                    renderArrow={this.myArrow}
                    itemsToShow = {4}
                >
                    {cards}
                </Carousel>
                {/* <CardSlider arrow={arrow} cards={cards} xsmall /> */}
            </div>
        );
    }
}
